import React, { useState, useEffect } from "react";
import { Grid, InputLabel, MenuItem } from "@mui/material";
import {
  PrimaryOutlinedButton,
  PrimaryLightInput,
  PrimaryLightSelect,
} from "../../theme/index";
import "../../sass/styles.scss";
import FormControl from "@mui/material/FormControl";
import { UseScreen } from "../../hooks/UseScreen.hook";
import { useDispatch } from "react-redux";
import { modalAction } from "../../redux/reducers/Modal";
import { editRoomAction } from "../../redux/reducers/Edit";
import axios from "axios";
import {collection, getDocs, addDoc, query} from 'firebase/firestore';
import db from "../../config/firebase";

const EditRoom = (props) => {
  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const [id, setId] = useState(props.room.id);
  const [roomNumber, setRoomNumber] = useState(props.room.roomNumber);
  const [category, setCategory] = useState(props.room.category);
  const [price, setPrice] = useState(props.room.price);
  const [expressPrice, setExpressPrice] = useState(props.room.expressPrice);
  const [levels, setLevels] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [level, setLevel] = useState(props.room.level);
  const [status, setStatus] = useState(props.room.status);
  const [details, setDetails] = useState(props.room.details);

  useEffect(() => {
    const getLevels = async () => {
      const q = query(collection(db, "level"));
      const querySnapshot = await getDocs(q);
      let levelsArray = [];
      querySnapshot.forEach((doc) => {
        levelsArray.push(doc.data());
      });
      setLevels(levelsArray);
    };

    const getCategories = async () => {
      const q = query(collection(db, "category"));
      const querySnapshot = await getDocs(q);
      let arrayCategories = [];
      querySnapshot.forEach((doc) => {
        arrayCategories.push(doc.data());
      });
      setCategoryList(arrayCategories);
    };

    getLevels();
    getCategories();
  }, []);

  const editRoom = () => {
    const roomEdited = new FormData();
    const dataNames = [
      "id",
      "roomNumber",
      "category",
      "price",
      "expressPrice",
      "level",
      "status",
      "details",
    ];

    roomEdited.append(dataNames[0], id);
    roomEdited.append(dataNames[1], roomNumber);
    roomEdited.append(dataNames[2], category);
    roomEdited.append(dataNames[3], price);
    roomEdited.append(dataNames[4], expressPrice);
    roomEdited.append(dataNames[5], level);
    roomEdited.append(dataNames[6], status);
    roomEdited.append(dataNames[7], details);
    roomEdited.append("METHOD", "PUT");

    dispatch(editRoomAction(roomEdited, dataNames, id));
    dispatch(modalAction());
  };

  return (
    <>
      <Grid item xs={10}>
        <h5 style={{ margin: "0" }}>Habitación / editar</h5>
      </Grid>
      <Grid item xs={12}>
        <Grid container sx={{ py: 6 }}>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Número"
              fullWidth
              value={roomNumber}
              onChange={(e) => setRoomNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Categoría</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                {categoryList.length > 0 &&
                  categoryList.map((item) => {
                    if (item.status == "true") {
                      return (
                        <MenuItem value={item.name.toLowerCase()}>
                          {item.name}
                        </MenuItem>
                      );
                    }
                  })}
                {/* <MenuItem value='double-bed'>Matrimonial</MenuItem>
                            <MenuItem value='personal'>Personal</MenuItem>
                            <MenuItem value='double'>Doble</MenuItem>
                            <MenuItem value='junior-suite'>Junior Suite</MenuItem>
                            <MenuItem value='suite'>Suite</MenuItem> */}
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Precio Estándar"
              fullWidth
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Precio Express"
              fullWidth
              value={expressPrice}
              onChange={(e) => setExpressPrice(e.target.value)}
            />
          </Grid>
          {/* <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Precio"
              fullWidth
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </Grid> */}
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Piso</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={level}
                onChange={(e) => setLevel(e.target.value)}
              >
                {levels.length > 0 &&
                  levels.map((item) => {
                    if (item.status == "true") {
                      return <MenuItem value={item.id}>{item.name}</MenuItem>;
                    }
                  })}
                {/* <MenuItem value={1}>Primer nivel</MenuItem>
                            <MenuItem value={2}>Segundo nivel</MenuItem>
                            <MenuItem value={3}>Tercer nivel</MenuItem> */}
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                {/* <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem> */}
                <MenuItem value="open">Abierto</MenuItem>
                <MenuItem value="close">Cerrado</MenuItem>
                <MenuItem value="cleaning">En limpieza</MenuItem>
                <MenuItem value="false">Inactivo</MenuItem>
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} className="pr-2">
            <PrimaryLightInput
              label="Detalles"
              fullWidth
              multiline
              rows={screenWidth > 500 ? 4 : 2}
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }} textAlign="end" className="pr-2">
        <PrimaryOutlinedButton onClick={() => editRoom()}>
          Guardar
        </PrimaryOutlinedButton>
      </Grid>
    </>
  );
};

export default EditRoom;
